import { Modal } from "flowbite-react";
import { useState } from "react";
import { HiOutlineCheckCircle } from "react-icons/hi";
import { useNavigate } from "react-router-dom";

export const SuccessModal = ({ show, onClose, message }) => {
    const navigate=useNavigate();
  return (
    <Modal show={show} onClose={onClose} size="md" popup>
      <Modal.Header />
      <Modal.Body>
        <div className="text-center">
          <HiOutlineCheckCircle className="mx-auto mb-4 h-14 w-14 text-green-500" />
          <h3 className="mb-5 text-lg font-normal text-gray-500">
            {message || "Operation completed successfully!"}
          </h3>
          <div className="flex justify-center">
            <button
              type="button"
              className="rounded-lg bg-green-500 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-green-600 focus:outline-none"
              onClick={()=>{navigate("/Utilisateurs")}}
            >
              OK
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};
